<template>
    <tr>
        <td style="background-color: #f3f2e9;">
            <span>
                {{item.hotel.name}}
            </span>
        </td>
        <td  style="background-color: #f3f2e9;">
            <span v-if="item.hotel.sub_zone != null">
                {{item.hotel.sub_zone.name}}
            </span>
        </td>
        <td v-for="(entry,idx) in item.list_pickups" :key="idx">
            <p v-if="entry.pickup != null && entry.service">
                {{entry.pickup.name}}
            </p>
            <p v-else-if="entry != null && entry.service == false" class="text-danger">
                NO SERVICE
            </p>
            <p v-else class="alert-danger">
                NOT CONFIGURED
            </p>
        </td>
        <td>
            <b-button
                class="border mr-2"
                size="sm"
                variant="light"
                @click="boundHotelToEdit"
                v-if="true"
            >
                <i class="text-center fa fa-wrench fa-fw"></i>
                Editar
            </b-button>
        </td>
    </tr>
</template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex';

export default {
    props: {
        item: {
            type: Object,
            required: true,
        },
        selectedSuprazone: {
            required: false,
        }
    },
    data() {
        return {

        }
    },
    methods: {
        async boundHotelToEdit() {
            // v-b-modal="'editRelationHotelPickup'"

            await this.$store.dispatch("hotelStopGroups/storeHotelEdit", {hotel: this.item})
            this.$bvModal.show('editRelationHotelPickup')
        }
    }
}
</script>